import React, { useRef, useEffect, useState } from "react";
var MarqueeIfOverflow = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.speed, speed = _c === void 0 ? 20 : _c;
    var containerRef = useRef(null);
    var textRef = useRef(null);
    var _d = useState(false), shouldMarquee = _d[0], setShouldMarquee = _d[1];
    var _e = useState(0), textWidth = _e[0], setTextWidth = _e[1];
    useEffect(function () {
        var checkOverflow = function () {
            if (containerRef.current && textRef.current) {
                setShouldMarquee(textRef.current.scrollWidth > containerRef.current.offsetWidth);
                setTextWidth(textRef.current.scrollWidth);
            }
        };
        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return function () { return window.removeEventListener("resize", checkOverflow); };
    }, [children]);
    return (React.createElement("div", { ref: containerRef, className: "relative overflow-hidden whitespace-nowrap ".concat(className), style: { minWidth: 0 } },
        React.createElement("div", { style: {
                display: "inline-flex",
                whiteSpace: "nowrap",
                willChange: "transform",
                animation: shouldMarquee
                    ? "marquee ".concat(speed, "s linear infinite")
                    : undefined,
            } },
            React.createElement("div", { ref: textRef, style: { display: "inline-block" } }, children),
            "\u00A0\u00A0",
            shouldMarquee && (React.createElement("div", { style: { display: "inline-block" }, "aria-hidden": "true" }, children))),
        shouldMarquee && (React.createElement("style", null, "\n            @keyframes marquee {\n              0% { transform: translateX(0); }\n              100% { transform: translateX(-".concat(textWidth, "px); }\n            }\n          ")))));
};
export default MarqueeIfOverflow;
